<div class="pricy-notice">
  <span>S&P Global Market Intelligence Privacy Notice</span>
</div>
<div class="col-xs-12 privacy-content">
  <div>
    <p>
      <strong>
        S&P Global Market Intelligence’s inclusion of your business contact
        information in our resources for capital markets professionals
      </strong>
    </p>
  </div>

  <div>
    <p>
      S&P Global Market Intelligence, a division of S&P Global, has collected
      your business contact information (such as your name, job title and/or
      function, business phone number, business postal address and business
      email address) and other information described in the
      “<strong>What Information we Collect and Process</strong>” section of this Privacy Notice
      (“<strong>Information</strong>”) from
      multiple sources, including from your counterparties throughout the global capital
      markets community, from you, and/or as otherwise described in the
      “<strong>How we Collect your Business Contact Information </strong>” section below,
      to include within our comprehensive resource of contacts in the global capital markets
      community. S&P Global Market Intelligence data is widely used to
      facilitate relevant business communication and information exchange among
      capital markets professionals and to assist Capital Markets Participants
      (as defined below) with regulatory compliance efforts. Please read this
      Privacy Notice to understand how S&P Global Market Intelligence processes
      your Information and how you can action your rights in relation to the processing of your Information.
    </p>
  </div>

  <div>
    <p>
      To enable S&P Global Market Intelligence to maintain the accuracy of its data, you can review your Information
      processed by us. To correct your Information, opt-out, or if you would prefer that S&P Global Market Intelligence
      does not process your Information as described in this Privacy Notice, please follow the instructions in the
      “<strong>Your
        Rights</strong>” section below.
    </p>
  </div>

  <h3 class="privacy-h3">About the S&P Global Market Intelligence Data</h3>

  <div>
    <p>
      S&P Global Market Intelligence data allows investors and capital markets
      professionals to work more efficiently in the market by helping to
      identify the appropriate recipients to receive information in connection
      with a particular financial opportunity. Capital markets professionals
      greatly benefit from having their Information conveniently available in
      our resources.
    </p>
  </div>

  <h3 class="privacy-h3">About us</h3>

  <div>
    <p>
      S&P Global Inc. and its affiliates are collectively
      referred to in this Privacy Notice as “<strong>S&P Global Market Intelligence</strong>” or “<strong>we</strong>”,
      “<strong>us</strong>” or
      “<strong>our</strong>”.
    </p>
  </div>

  <div>
    <p>
      S&P Global (NYSE: <strong>SPGI</strong>) provides essential intelligence.
      We enable governments, businesses and individuals with the right data,
      expertise and connected technology so that they can make decisions with
      conviction. From helping our customers assess new investments to guiding
      them through ESG and energy transition across supply chains, we unlock new
      opportunities, solve challenges, and accelerate progress for the world.
    </p>
  </div>

  <div>
    <p>
      We are widely sought after by many of the world's leading organizations to
      provide credit ratings, benchmarks, analytics, and workflow solutions in
      the global capital, commodity and automotive markets. With every one of
      our offerings, we help the world's leading organizations plan for
      tomorrow, today.
    </p>
  </div>

  <div>
    <p>
      S&P Global Market Intelligence is a business division of S&P Global.
      S&P Global also has other divisions such as: S&P Dow
      Jones Indices, S&P Global Commodity Insights, S&P Global Mobility, and S&P
      Global Ratings, each of which provides different products and services.
      S&P Global keeps the
      activities of its business divisions separate from each other in order to
      preserve the independence and objectivity of their activities in
      accordance with the S&P Global Divisional Independence and Objectivity
      Policy. S&P Global Market Intelligence produces information
      including price assessments and indices. S&P Global maintains clear structural
      and operational separation between its price assessment activities and the
      other activities carried out by S&P Global Market Intelligence and the
      other business divisions of S&P Global to safeguard the quality, independence
      and integrity of its price assessments and indices and ensure they are
      free from any actual or perceived conflicts of interest.
    </p>
  </div>

  <h3 class="privacy-h3">
    How we collect your Business Contact Information
  </h3>

  <div>
    <p>
      The Information contained within S&P Global Market Intelligence resource
      relate to individuals and companies in the global capital markets
      community (“<strong>Capital Markets Participants</strong>”). The
      Information may be independently collected by the S&P Global Market
      Intelligence research department typically from public sources including
      content made public on professional network websites, other websites,
      public regulatory filings and public news sources, or inferred through standard corporate email format and
      verified through a quality assurance process. We also obtain and may
      validate Information from your company’s website and from conversations
      with you or other professionals in your organization and/or from your
      counterparties throughout the global capital markets community. Collection, quality assurance, and/or content may
      be created or processed with the assistance of artificial intelligence technologies that that are reviewed and
      overseen that are reviewed and overseen by S&P Global Market Intelligence personnel. In using
      the public sources, S&P Global Market Intelligence is careful to collect
      only Information necessary for the purposes described in this Privacy
      Notice and to review and verify all Information we collect from such
      sources.
    </p>
  </div>

  <h3 class="privacy-h3">
    What Information we Collect and Process
  </h3>

  <div>
    <p>
      We may collect and process any or all of the following types of
      Information about you: name, age, gender, company association, telephone
      number (general or direct business numbers, fax, and/or mobile numbers),
      business email address, job title and/or function, office address, work
      and education history, professional affiliations, public and private
      markets investments, holdings and coverage, compensation, insider
      holdings and activity, professional board and committee memberships, as
      well as links to social media and professional networking sites. To view the information we have about you, please
      follow the instructions in the “<strong>Your Rights</strong>” section below.
    </p>
  </div>

  <h3 class="privacy-h3">How we use your Information</h3>

  <h3 class="privacy-h3">Capital Markets Participants Resource</h3>

  <div>
    <p>
      We process the Information to compile a comprehensive resource of Capital
      Markets Participants, and to market such data to clients, including
      clients outside of Switzerland, who license S&P Global Market Intelligence
      products and services, including the data itself. The primary purpose of
      the data is to provide to S&P Global Market Intelligence clients a
      comprehensive resource of Capital Markets Participants, which they may use
      to facilitate relevant business to business communication and information
      exchange with such contacts (see “<strong>Information Sharing</strong>”
      below) and for marketing of S&P Global Market Intelligence products and
      services where permitted by applicable law (see “<strong>Marketing</strong>” below).
    </p>
  </div>

  <div>
    <p>
      We may also use your Information to contact you to verify the Information
      we collect about you from public sources, and to obtain information from
      you on behalf of our clients, such as compliance certificates in
      connection with the capital markets transactions in which you participate
      on behalf of your employer.
    </p>
  </div>

  <h3 class="privacy-h3">Information Sharing</h3>

  <div>
    <p>
      As described above, we may share or license your Information internally
      within our family of affiliate companies and to unaffiliated third parties
      including, but not limited to capital market professionals, including
      banks, public and private companies, institutional and individual
      investors, research, asset management and wealth management firms, so that
      they may use such Information for the limited purpose of contacting you
      regarding capital markets opportunities relevant to your business.
      We will use our reasonable business efforts to
      enter into arrangements that require such third parties to limit their use
      of your Information to those consistent with applicable law and this Privacy Notice unless
      they obtain your consent to use your Information for any other purpose.
    </p>
  </div>

  <div>
    <p>
      We will stop providing your Information to third parties for use as
      described above if and once you inform us of your opt-out preferences by
      following the instructions in the “<strong>Your Rights</strong>” section
      below. You can also ask any third party from whom you receive
      communication to stop processing your Information and to opt-out from
      their marketing or any other communication.
    </p>
  </div>

  <div>
    <p>
      The storing of your Information in our resources, and sharing your
      Information with, or licensing your Information to, third parties as
      described above, will involve the transfer of your Information outside
      Switzerland to countries where S&P Global (including its affiliates)
      operate and the sharing of your Information from the database with clients
      in any third country. When we transfer your Information outside
      Switzerland, we will put in place an adequate level of protection where required to
      comply with applicable Swiss or any other applicable
      data protection laws, including with respect to transfers among S&P Global
      Market Intelligence affiliates. If you require further information about this
      protective measure, you can request it from
      <a href="mailto:data.preferences@spglobal.com">data.preferences@spglobal.com</a>.
    </p>
  </div>

  <h3 class="privacy-h3">
    Marketing
  </h3>

  <div>
    <p>
      Where permitted by law, S&P Global Market Intelligence may use your Information to contact
      you regarding our products and services and we may send you
      product-related news and other news and information that we believe may be
      of interest to your organization and/or business. You can opt-out from
      receiving this direct marketing communication by following the instructions in the “<strong>Your Rights</strong>”
      section below.
    </p>
  </div>

  <div>
    <p>
      Please note that if you do opt-out from direct marketing by using the
      option below, we may still need to process some limited Information to
      ensure that you receive no further marketing communication from us. We may
      also still send you important administrative messages as part of your
      ongoing use of our products and services, if applicable.
    </p>
  </div>

  <h3 class="privacy-h3">Lawful Purposes for Processing</h3>
  <div>
    <p>
      Where relevant, S&P Global Market Intelligence relies on the legitimate
      interests ground for processing the Information. In doing so, S&P Global
      Market Intelligence has assessed its position, balancing the rights and
      freedoms of data subjects against the company’s own interests. S&P Global
      Market Intelligence considers its data processing necessary for the
      purposes of its legitimate interests in providing its data to clients. As
      described above, S&P Global Market Intelligence has collected or otherwise
      acquired your Information to include within its comprehensive resource of
      contacts in the global capital markets community.
    </p>
  </div>

  <h3 class="privacy-h3">Retention</h3>
  <div style="white-space: pre-line;">
    <p>
      We retain your Information for as long as we reasonably require it for
      legal, business, or contractual purposes. In determining data retention
      periods, we take into consideration local laws, contractual obligations,
      our reasonable business requirements and your expectations and
      requirements. When we no longer need your Information, we securely delete
      or destroy it.
    </p>
  </div>

  <h3 class="privacy-h3">Your Rights</h3>

  <div style="white-space: pre-line;">
    <p>
      You may have the right to access the Information that we process about you
      and to request that we correct, amend, or delete it if it is inaccurate or
      processed in breach of applicable laws, if such right is provided by law
      in the applicable jurisdiction. These rights may not apply in some cases
      and, if you make a request, we shall inform you if that is the case. If
      you would like to request access to, or a correction or amendment to, your
      Personal Information or request deletion of your Personal Information you
      can submit a written request to
      <a href="mailto:data.preferences@spglobal.com">data.preferences@spglobal.com</a>
    </p>
  </div>

  <div>
    <p>
      We will investigate and attempt to resolve any complaints or disputes we
      receive regarding the processing of your Information pursuant to applicable law. To the extent your
      Information is governed and protected by Swiss data protection laws and
      you are unsatisfied with the resolution of any complaint, you may contact
      the Federal Data Protection and Information Commissioner (FDPIC) for
      further information and assistance.
    </p>
  </div>

  <h3 class="privacy-h3">How to Contact Us</h3>

  <div style="white-space: pre-line;">
    <p>
      Your questions, comments and feedback are very important to us. For
      privacy-related issues or questions, please contact us at
      <a href="mailto:data.preferences@spglobal.com">data.preferences@spglobal.com.</a>
      S&P Global’s Zurich office address is: Neumühlequai 6, 8001 Zurich,
      Switzerland.
    </p>
  </div>

  <div style="white-space: pre-line;">
    <p>
      For information on general principles which we follow in handling personal
      information we collect for the purposes other than stated herein please
      visit our
      <a target="_blank"
        href="https://www.spglobal.com/en/privacy/privacy-policy-english"> Global Corporate Privacy Policy</a>
    </p>
  </div>

  <p>Updated March 1, 2025.</p>
</div>